import React from "react";
import { Sparkles, Zap, Rocket, Check } from "lucide-react";

const APP_URL = "https://app.fittrackcoach.in";

const PERKS = [
  {
    icon: Zap,
    title: "Founder's pricing — locked in",
    desc: "Join now and lock in our lowest rates forever. No price hikes, no surprise renewals.",
  },
  {
    icon: Sparkles,
    title: "Shape the roadmap",
    desc: "Tell us what you need for your coaching business. Early coaches get real influence on what we build next.",
  },
  {
    icon: Rocket,
    title: "White-glove onboarding",
    desc: "We personally help you migrate from Excel/Sheets, set up your first clients, and get your first workout live.",
  },
];

export default function FirstCoaches() {
  return (
    <section className="py-20 md:py-28 relative" data-testid="first-coaches-section">
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(ellipse at 50% 0%, rgba(34,211,238,0.08), transparent 60%)" }}
      />
      <div className="section-container relative">
        <div className="text-center max-w-3xl mx-auto mb-12 reveal">
          <div className="chip mb-4">
            <span className="dot-live" /> Early access
          </div>
          <h2 className="font-display text-4xl md:text-5xl leading-tight">
            Be one of the first <span className="gradient-text">100 coaches</span> building smarter businesses
          </h2>
          <p className="mt-4 text-white/60">
            FitTrackCoach is just getting started. Join now, lock in founder pricing, and build the product together with us.
          </p>
        </div>

        {/* Spots visual */}
        <div className="max-w-3xl mx-auto mb-12 reveal" data-testid="spots-visual">
          <div className="flex items-center justify-between mb-3">
            <div className="text-xs uppercase tracking-widest text-white/50 font-semibold">
              Founding coach spots
            </div>
            <div className="text-xs font-bold text-cyan-300">Limited to 100</div>
          </div>
          <div
            className="grid gap-1"
            style={{ gridTemplateColumns: "repeat(50, minmax(0, 1fr))" }}
          >
            {Array.from({ length: 100 }).map((_, i) => (
              <div
                key={i}
                className="h-3 rounded-[2px]"
                style={{
                  background:
                    i < 17
                      ? "linear-gradient(135deg, #22D3EE, #3B82F6)"
                      : "rgba(255,255,255,0.05)",
                  border: i < 17 ? "none" : "1px solid rgba(255,255,255,0.05)",
                }}
              />
            ))}
          </div>
          <div className="mt-3 flex items-center justify-between text-xs text-white/55">
            <span>Spots are filling up with early coaches every week.</span>
            <span className="text-cyan-300 font-semibold">Claim yours today</span>
          </div>
        </div>

        {/* Perks */}
        <div className="grid md:grid-cols-3 gap-5 mb-10">
          {PERKS.map((p, i) => {
            const Icon = p.icon;
            return (
              <div key={i} className="card-surface rounded-2xl p-6 reveal" data-testid={`perk-${i}`}>
                <div
                  className="w-11 h-11 rounded-xl flex items-center justify-center mb-4"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(34,211,238,0.2), rgba(59,130,246,0.15))",
                    border: "1px solid rgba(34,211,238,0.3)",
                  }}
                >
                  <Icon size={20} className="text-cyan-300" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">{p.title}</h3>
                <p className="text-sm text-white/60 leading-relaxed">{p.desc}</p>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center reveal">
          <a
            href={APP_URL}
            className="btn-primary-glow rounded-xl px-7 py-4 text-base inline-flex items-center gap-2"
            data-testid="first-coaches-cta"
          >
            Claim your founding spot
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
            </svg>
          </a>
          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/50">
            <span className="inline-flex items-center gap-1.5"><Check size={12} className="text-cyan-400"/> No credit card required</span>
            <span className="inline-flex items-center gap-1.5"><Check size={12} className="text-cyan-400"/> Founder pricing locked forever</span>
            <span className="inline-flex items-center gap-1.5"><Check size={12} className="text-cyan-400"/> Setup in under 2 minutes</span>
          </div>
        </div>
      </div>
    </section>
  );
}
